// 字典数据管理
const dictStore = {
  namespaced: true,
  state: () => ({
    // 字典数据缓存
    dictCache: {}
  }),
  
  getters: {
    // 获取字典数据
    getDict: (state) => (dictType) => {
      return state.dictCache[dictType] || []
    },
    
    // 获取字典标签
    getDictLabel: (state) => (dictType, value) => {
      const dictList = state.dictCache[dictType] || []
      const item = dictList.find(item => item.value === value)
      return item ? item.label : ''
    }
  },
  
  mutations: {
    // 设置字典数据
    setDict(state, { dictType, dictList }) {
      state.dictCache[dictType] = dictList
    },
    
    // 清除字典数据
    clearDict(state, dictType) {
      if (dictType) {
        delete state.dictCache[dictType]
      } else {
        state.dictCache = {}
      }
    }
  },
  
  actions: {
    // 设置字典数据
    setDict({ commit }, { dictType, dictList }) {
      commit('setDict', { dictType, dictList })
    },
    
    // 清除字典数据
    clearDict({ commit }, dictType) {
      commit('clearDict', dictType)
    }
  }
}

export default dictStore
